import React, { useState } from 'react';
import { GraduationCap, CheckCircle2, Clock, Plus, Target, Award } from 'lucide-react';

export const StudentIEPModule: React.FC = () => {
  const [goals, setGoals] = useState([
    { id: '1', title: 'Independent AAC Sentence Formation', domain: 'Communication', progress: 75, targetDate: 'Dec 2026' },
    { id: '2', title: 'Fine Motor Pencil Grip Stability', domain: 'Occupational Therapy', progress: 60, targetDate: 'Nov 2026' },
    { id: '3', title: 'Peer Group Social Interaction', domain: 'Behavioral / Social', progress: 85, targetDate: 'Oct 2026' },
  ]);

  const handleUpdateProgress = (id: string, delta: number) => {
    setGoals(goals.map(g => {
      if (g.id === id) {
        const next = Math.min(100, Math.max(0, g.progress + delta));
        return { ...g, progress: next };
      }
      return g;
    }));
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm space-y-6">
      <div className="flex items-center justify-between border-b border-slate-100 pb-4">
        <div>
          <span className="px-2.5 py-0.5 bg-emerald-100 text-emerald-800 text-[10px] font-bold rounded-full uppercase tracking-wider">
            SEIS & SpedTrack Benchmark
          </span>
          <h2 className="text-2xl font-bold text-slate-900 mt-1">Student Profile & SMART IEP Goals</h2>
          <p className="text-xs text-slate-500">Individualized Education Program milestones, accommodations, and progress tracking</p>
        </div>
      </div>

      {/* Goal Cards List */}
      <div className="space-y-4">
        <h3 className="text-xs font-bold text-slate-500 uppercase tracking-wider">Active IEP SMART Goals</h3>
        <div className="space-y-3">
          {goals.map((goal) => (
            <div key={goal.id} className="p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-3">
              <div className="flex items-center justify-between">
                <div>
                  <span className="text-[10px] font-bold px-2 py-0.5 rounded bg-emerald-100 text-emerald-800 uppercase">
                    {goal.domain}
                  </span>
                  <h4 className="text-sm font-bold text-slate-900 mt-1">{goal.title}</h4>
                </div>
                <div className="text-right">
                  <div className="text-lg font-black text-emerald-700">{goal.progress}%</div>
                  <div className="text-[10px] text-slate-500">Target: {goal.targetDate}</div>
                </div>
              </div>

              {/* Progress Slider */}
              <div className="space-y-1">
                <div className="w-full bg-slate-200 rounded-full h-2.5 overflow-hidden">
                  <div className="bg-emerald-500 h-full rounded-full transition-all duration-500" style={{ width: `${goal.progress}%` }} />
                </div>
                <div className="flex justify-end gap-2 pt-1">
                  <button 
                    onClick={() => handleUpdateProgress(goal.id, -5)}
                    className="px-2 py-0.5 bg-white border border-slate-300 text-slate-700 text-[10px] font-bold rounded hover:bg-slate-100"
                  >
                    -5%
                  </button>
                  <button 
                    onClick={() => handleUpdateProgress(goal.id, 5)}
                    className="px-2 py-0.5 bg-emerald-600 text-white text-[10px] font-bold rounded hover:bg-emerald-700 shadow-sm"
                  >
                    +5%
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
